import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import EntrarParaDoar from "@/pages/EntrarParaDoar";

export const Route = createFileRoute("/entrar-para-doar")({
  head: () => seoHead({
    title: "Entrar para doar | Shopping do Bem",
    description: "Entre na sua conta para ativar a doação da sua compra.",
    path: "/entrar-para-doar",
    noindex: true,
  }),
  component: EntrarParaDoar,
});
